import React from 'react';
import { Link } from 'react-router-dom';
import { RichText } from '../RichText';
import { ContactForm } from '../ContactForm';
import { company } from '../../data/company';
export function ContactSection() {
  return <section id="contact" aria-labelledby="contact-heading" className="scroll-mt-16 border-t border-line" data-id="element-80" data-mp="1v43jhl1ic572">
      <div className="mx-auto grid max-w-6xl gap-12 px-5 py-16 sm:px-8 md:py-20 lg:grid-cols-[1fr_1.4fr]" data-id="element-81" data-mp="202dftyyyxbu9">
        <div data-id="element-82" data-mp="1m2lxxn5bzbaz">
          <h2 id="contact-heading" className="font-serif text-3xl font-semibold tracking-tight text-ink" data-id="element-83" data-mp="1m69rgmarzxpp">Contact</h2>
          <p className="mt-3 leading-relaxed text-muted" data-id="element-84" data-mp="1c60pssy0lk2x">Questions about a product, delivery, or a refund? Send us a message.</p>
          <dl className="mt-8 space-y-5 text-sm" data-id="element-85" data-mp="1h4alr5rkcopl">
            <div data-id="element-86" data-mp="1h76k2v7bpfek">
              <dt className="text-muted" data-id="element-87" data-mp="36k0jq5esqbjl">Email</dt>
              <dd className="mt-1 text-base font-medium text-ink" data-id="element-88" data-mp="36lbn444bxha6"><RichText text={company.email} data-id="element-89" data-mp="3bj4vn3t3undm" /></dd>
            </div>
            <div data-id="element-90" data-mp="3bibs0bpg0dzp">
              <dt className="text-muted" data-id="element-91" data-mp="3bgqx2kz7ut1b">Response time</dt>
              <dd className="mt-1 font-medium text-ink" data-id="element-92" data-mp="27i7je10q6iyt"><RichText text={company.responseTime} data-id="element-93" data-mp="22kfjajpxfqjj" /></dd>
            </div>
          </dl>
          <div className="mt-8 border-t border-line pt-6 text-sm leading-relaxed text-muted" data-id="element-94" data-mp="22il83x4gjcsn">
            <p className="font-medium text-ink" data-id="element-95" data-mp="2hberhtmuod2l">Order issue?</p>
            <p className="mt-1" data-id="element-96" data-mp="2cbjxvibox9du">
              Include your order number and the email used at checkout. See the{' '}
              <Link to="/policies#delivery" className="font-medium text-accent underline-offset-4 hover:underline" data-id="element-97" data-mp="1okwostq1gdpp">Digital Delivery Policy</Link> for common fixes.
            </p>
          </div>
        </div>
        <ContactForm data-id="element-98" data-mp="1xj8aqifymnbt" />
      </div>
    </section>;
}